module.exports = "<!-- Copyright The Linux Foundation and each contributor to LFX. -->\n<!-- SPDX-License-Identifier: MIT -->\n<div class=\"loader\" *ngIf=\"(loadable$ | async)?.status === LOADING\" i18n>Loading...</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/loading-spinner/loading-spinner.component.html
// module id = ./src/app/shared/loading-spinner/loading-spinner.component.html
// module chunks = main